export const dotNotationToBracket = (str) => {
  return str.split('.').reduce(function(a, b) {
    return `${a}[${b}]`;
  });
}
